<template>
  <div id="room-wrapper">
    <h1 class="title">{{roomData.uuid}}</h1>
    <room-help @stringUpdated="updateMedia(...arguments)" :orgdata="helpData"></room-help>
  </div>
</template>

<script>
import RoomData from '@/mixins/RoomMixin'

export default {
  name: 'Startportal',
  mixins: [RoomData],
  data () {
    return {
      data: {
        title: 'Startportal'
      }
    }
  },
  computed: {},
  components: {},
  methods: {
    log: function (item) {
      console.log(item)
    }
  },
  mounted () {
  }
}
</script>
